import { createSlice, createSelector } from '@reduxjs/toolkit'

const initialState = {
  smsDeactivatedPopup: {
    isOpen: false
  }
}

const slice = createSlice({
  name: 'workflows/modals',
  initialState,
  reducers: {
    openSmsDeactivatedPopup(state) {
      state.smsDeactivatedPopup.isOpen = true
    },
    closeSmsDeactivatedPopup(state) {
      state.smsDeactivatedPopup.isOpen = false
    },
  }
})

const sliceSelector = (state) => state.workflows.modals
export const isSmsDeactivatedPopupOpenSelector = createSelector(sliceSelector, ({ smsDeactivatedPopup }) => smsDeactivatedPopup.isOpen)

export const { reducer, actions: { closeSmsDeactivatedPopup, openSmsDeactivatedPopup } } = slice
